import React from 'react';
import PropTypes from 'prop-types';

const StopCircleContainedIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.833008 8.33325C0.833008 4.19112 4.19087 0.833252 8.33301 0.833252C12.4751 0.833252 15.833 4.19112 15.833 8.33325C15.833 12.4754 12.4751 15.8333 8.33301 15.8333C4.19087 15.8333 0.833008 12.4754 0.833008 8.33325Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinejoin="round"
    />
    <path
      d="M5.52051 6.57544C5.52051 5.99295 5.99271 5.52075 6.5752 5.52075H10.0908C10.6733 5.52075 11.1455 5.99295 11.1455 6.57544V10.0911C11.1455 10.6736 10.6733 11.1458 10.0908 11.1458H6.5752C5.99271 11.1458 5.52051 10.6736 5.52051 10.0911V6.57544Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinejoin="round"
    />
  </svg>
);

StopCircleContainedIcon.propTypes = {
  color: PropTypes.string,
};

export default StopCircleContainedIcon;
